import { Table } from 'ui/table';
import { TableHeader } from 'ui/tableHeader';
import { TableRows } from 'ui/tableRows';
import { COLUMNS } from './CNAMEColumns';
import { SectionContainer, StyledH3 } from './TrackingDomain.styled';
import type { TrackingDomain } from '../types';

const TEXT = {
  header: 'CNAME',
  description: 'Select a deep link provider',
  provider: 'Iterable',
  editProviderCTA: 'Edit Provider',
};

type CNameProps = {
  trackingDomain: TrackingDomain;
};

export const CNAME = ({ trackingDomain }: CNameProps) => {
  return (
    <SectionContainer data-test="CNAME-details-container">
      <StyledH3>{TEXT.header}</StyledH3>
      <Table>
        <TableHeader columns={COLUMNS} />
        <TableRows idKey="domain" columns={COLUMNS} rows={[trackingDomain]} />
      </Table>
    </SectionContainer>
  );
};
